import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { TermsOfUseComponent } from './terms-of-use.component';

@NgModule({
  imports: [
    NgbModule,
    CommonModule,
  ],
  declarations: [
    TermsOfUseComponent,
  ]
})
export class TermsOfUseModule { }
